import React, { Component } from 'react';
// utils
import { Translations } from '../../../../../utils';
// style
import './CustomerFilter.css';

class CustomerFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerStr: '',
      emailStr: ''
    }
  }

  searchCustomerHandler = (event) => {
    this.setState({
      customerStr: event.target.value
    })
    this.props.searchCustomerHandler(event.target.value);
  }

  searchText = () => {
    if (this.state.emailStr !== '') {
      this.props.resetApiCall(this.state.emailStr)
    }
  }


  searchItmeHandler = (event) => {
    this.setState({
      emailStr: event.target.value
    })
    //this.props.searchEmailHandler(event.target.value);
  }

  forceUpdateCustom = () => {
    this.setState({
      emailStr: ''
    })
    this.props.showFilters === true && this.props.getStatusOnchange('');
    this.props.clearAll();
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {
    return (
      <div className="gdoc-caselist-filter">
        <div className="gdoc-caselist-filter-search searchListform emailSearch">
          <label className="customerlbl">{this.translations(this.props.serchTitleHeader.filterTitle2)}</label>
          <input
            type="text"
            maxLength="100"
            id="searchEntityText"
            className="form-control form-control-lg"
            value={this.state.emailStr}
            onChange={(event) => this.searchItmeHandler(event)}
          />
        </div>
        <div className="gdoc-caselist-filter-search button-width">
          <button aria-label="Delete Group" className="gdocs-btn-delete" onClick={this.searchText}>
            {Translations(this.props.serchTitleHeader.searchbtntext, this.props.lang.currentLang.lang, this.props.lang.translatedData)} &nbsp;
            <i class="glyphicon glyphicon-search"></i>
          </button>
        </div>
        <div className="clearAll">
          <span
            onClick={() => this.forceUpdateCustom()}
            role="link"
            tabIndex="0"
          >
            {this.translations(this.props.clearFilterText)}
          </span>
        </div>
      </div>
    )
  }
}

CustomerFilter.defaultProps = {
  caseStatus: [],
  caseOwner: []
}

CustomerFilter.propTypes = {

};

export default CustomerFilter;



// WEBPACK FOOTER //
// ./src/components/Admin/AdminPanel/SubComp/Grid/CustomerFilter.js